<template>
    <div>
        <v-icon name="io-close-outline" scale="1.3" class="close-icon" />
    </div>
</template>

<script>
import { OhVueIcon, addIcons } from 'oh-vue-icons';
// import { IoCloseCircleOutline } from 'oh-vue-icons/icons';
import { IoCloseOutline } from 'oh-vue-icons/icons';


addIcons(IoCloseOutline);

export default {
    components: {
        "v-icon": OhVueIcon
    }
}
</script>

<style scoped>
.close-icon {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    cursor: pointer;
    color: #474646;
}
</style>